// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// App Info
export const APP_NAME = process.env.REACT_APP_NAME || 'Touchline CMS';
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0';

// Feature Flags
export const ENABLE_MOCK_API = process.env.REACT_APP_ENABLE_MOCK_API === 'true';
export const ENABLE_DEBUG = process.env.REACT_APP_ENABLE_DEBUG === 'true';

// Third-party Services
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// Environment
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
